module.exports = __webpack_public_path__ + "static/img/theme_03.bbab938e.png";